<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B4J5vv/tc-custom/9780374716134.jpg?1730580684537" alt="This image is the cover for the book Neighborhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Neighborhood
      </h1>
      <p class="bookDescription body article font2">
        <b>A tabloid sex scandal leads to murder in the Nobel laureate’s politically charged thriller set among the wealthy elite of 1990s Peru.</b><br/><br/>Through the 1990s, Peruvian president Alberto Fujimori oversaw a deeply corrupt society. Those among the elite enjoyed privilege beyond imagining. But two couples from Lima’s upper class are about to become embroiled in a disturbing vortex of erotic adventures and politically driven blackmail.<br/><br/>Enrique, a high-profile businessman, receives a visit from notorious tabloid editor Rolando Garro, who attempts to blackmail him with graphic pictures from an old business trip. When Enrique refuses to pay, the images are on the front page. Meanwhile, Enrique’s wife is in the midst of a passionate affair with the wife of Enrique’s lawyer and best friend. When Garro shows up murdered, the two couples must navigate the unspoken laws and customs of Peru’s criminal underworld, while the magazine staff embarks on its greatest exposé yet.<br/><br/>A twisting, unpredictable tale, <i>The Neighborhood</i> is at once a scathing indictment of Fujimori’s regime and a crime thriller that evokes the vulgarity of freedom in a corrupt system.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mario Vargas Llosa, Edith Grossman
      </h2>
      
      <p class="authorDescription body article"><P><B>Mario Vargas Llosa </B>was awarded the Nobel Prize in Literature in 2010 “for his cartography of structures of power and his trenchant images of the individual’s resistance, revolt, and defeat.” He has also won the Cervantes Prize, the Spanish-speaking world’s most distinguished literary honor. His many works include <I>The Discreet Hero</I>, <I>The Feast of the Goat</I>, <I>The Bad Girl</I>, and <I>Aunt Julia and the Scriptwriter</I>, all published by FSG.<br><br><B>Edith Grossman</B> has translated the works of the Nobel laureates Mario Vargas Llosa and Gabriel García Márquez, among others. Her version of Miguel de Cervantes’s <I>Don Quixote </I>is considered the finest translation of the Spanish masterpiece in the English language.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ed9e738